function Passwords() {
    return (
        <div>
            <h2>Passwords</h2>

            <p>
                Your complete information comes here.
            </p>
        </div>
    );
}

export default Passwords;